import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'https://admin.1oneplus.net/api';

export const loginUser = createAsyncThunk(
  'auth/login',
  async ({ email, password, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/login`,
        {
          email,
          password,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'lang': lang || 'en',
          },
        }
      );

      if (response.data.status === false) {
        return rejectWithValue(response.data.message || 'Login failed');
      }

      // Store token in localStorage
      if (response.data.data?.token) {
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        // Add for compatibility with other actions
        localStorage.setItem('userTools', JSON.stringify({
          token: response.data.data.token,
          user: response.data.data.user
        }));
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response);
        if (error.response.status === 410) {
          return rejectWithValue({
            status: 410,
            message: error.response.data.message,
            data: error.response.data.data
          });
        }
        return rejectWithValue(error.response.data.message || 'Login failed');
      }
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const loginWithSocial = createAsyncThunk(
  'auth/loginWithSocial',
  async ({ id_token, device_name, lang }, { rejectWithValue }) => {
    console.log({ id_token, device_name, lang });
    
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/firebase-login`,
        {
          id_token,
          device_name,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'lang': lang || 'en',
          },
        }
      );
      console.log({ response });

      if (response.data.status === false) {
        return rejectWithValue(response.data.message || 'Social login failed');
      }

      // Store token in localStorage
      if (response.data.data?.token) {
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        // Add for compatibility with other actions
        localStorage.setItem('userTools', JSON.stringify({
          token: response.data.data.token,
          user: response.data.data.user
        }));
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message || 'Social login failed');
      }
      return rejectWithValue(error.message || 'Network error');
    }
  }
);
// export const loginWithSocial = createAsyncThunk(
//   'auth/loginWithSocial',
//   async ({ id_token, device_name, lang }, { rejectWithValue }) => {
//     console.log({id_token, device_name, lang});
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/auth/user/firebase-login`,
//         {
//           id_token,
//           device_name,
//         },
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json',
//             'lang': lang || 'en',
//           },
//         }
//       );
// console.log({response});

//       if (response.data.status === false) {
//         return rejectWithValue(response.data.message || 'Social login failed');
//       }

//       // Store token in localStorage
//       if (response.data.data?.token) {
//         localStorage.setItem('token', response.data.data.token);
//         localStorage.setItem('user', JSON.stringify(response.data.data.user));
//         // Add for compatibility with other actions
//         localStorage.setItem('userTools', JSON.stringify({
//           token: response.data.data.token,
//           user: response.data.data.user
//         }));
//       }

//       return response.data;
//     } catch (error) {
//       if (error.response) {
//         return rejectWithValue(error.response.data.message || 'Social login failed');
//       }
//       return rejectWithValue(error.message || 'Network error');
//     }
//   }
// );
